import React, {useContext, useMemo} from 'react';
import {Operation} from "../common/types/Types";
import {Animated} from "react-animated-css";
import Footer from "../common/views/Footer";
import LotList from "../lot/LotList";
import ReserveList from "../reserve/ReserveList";
import {StatisticsView} from "../statistics/StatisticsView";
import EnterpriseCorpEtatList from "./tabs/EnterpriseCorpEtatList";
import KeyDocumentList from "./tabs/KeyDocumentList";
import {
    useOperation,
    useOperationElements,
    useOperationEnterprises,
    useOperationLots,
    useOperationReserves
} from "../api/hooks";
import {CommonHelper} from "../common/CommonHelper";
import {Link, Route, useLocation, useRouteMatch} from "react-router-dom";
import {UserOperationAdmin} from "../user/UserOperationAdmin";
import {AuthContext} from "../providers/AuthProvider";

export const OperationScreen = (props) => {
    const operationId = parseInt(props.match.params.operationId);
    const {canViewOperationUsers} = useContext(AuthContext);

    const {data: operation = {} as Operation} = useOperation(operationId);
    const {data: lots = [], isLoading: isLoadingLots} = useOperationLots(operationId);
    const {data: reserves = [], isLoading: isLoadingReserves} = useOperationReserves(operationId);
    const {data: elements = [], isLoading: isLoadingElements} = useOperationElements(operationId);
    const {data: enterprises = [], isLoading: isLoadingEnterprises} = useOperationEnterprises(operationId);

    const {url} = useRouteMatch();
    const {pathname} = useLocation();

    lots.forEach((lot) => {
        CommonHelper.completeLotVisiteDates(lot);
    });

    lots.forEach((lot) => {
        const lotReserves = reserves.filter(r => r.lotRefLot === lot.refLot && !r.indicSupprime && !r.indicRas);
        const lotReservesNonLevee = lotReserves.filter(r => r.statutRefStatut === 1);

        lot.totalReserves = lotReserves.length;
        lot.pendingReserves = lotReservesNonLevee.length;
        lot.reservePhases = lotReserves.reduce((phaseIds, r) => {
            if (!phaseIds.includes(r.phaseRefPhase)) {
                phaseIds.push(r.phaseRefPhase);
            }

            return phaseIds;
        }, []);
    });

    reserves.forEach(reserve => reserve.lot = lots.find(lot => lot.refLot === reserve.lotRefLot));

    const UserAdminScreenMemoized = useMemo(() => <UserOperationAdmin operationId={operationId}/>,[operationId]);

    return <>
        <Animated className="page-container" animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>

            <div className="container">
                <div className="row">
                    <div className="col-9">
                        <h3 className="my-4 color-green">
                            {operation.nomOperation}&nbsp;&nbsp;
                            <small className="color-blue">
                                <b>{operation.codeUc}-{operation.codeCi}</b>&nbsp;&nbsp;
                                {operation.cp} {operation.ville}
                            </small>
                        </h3>
                    </div>
                    <div className="col-3">
                        <div className="tool-buttons-container">
                            <Link type="submit"
                                  className="btn btn-warning"
                                  to={`${process.env.PUBLIC_URL}/reserve/new/operation/${operation.refOperation}`}
                            >
                                Créer réserve <i className="fa fa-plus"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">

                <ul className="nav nav-tabs mt-2" role="tablist">
                    <li className="nav-item" role="presentation">
                        <Link to={`${url}/statistics`}
                              className={`nav-link ${pathname.includes('statistics')  || pathname === url ? 'active' : ''}`}
                        >
                            Statistiques <i className="fas fa-chart-bar"></i>
                        </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                        <Link to={`${url}/lot`}
                              className={`nav-link ${pathname.includes('lot') ? 'active' : ''}`}
                        >
                            Lots ({lots.length}) <i className="fas fa-building"/>
                        </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                        <Link to={`${url}/reserve`}
                              className={`nav-link ${pathname.includes('reserve') ? 'active' : ''}`}
                        >
                            Réserves ({reserves.length}) <i className="fas fa-fire"></i>
                        </Link>
                    </li>
                    <li className="nav-item" role="presentation">
                        <Link to={`${url}/enterprise`}
                              className={`nav-link ${pathname.includes('enterprise') ? 'active' : ''}`}
                        >
                            Entreprises ({enterprises.length}) <i className="fas fa-hard-hat"></i>
                        </Link>
                    </li>
                    <li className="nav-item" role="presentation">

                        <Link to={`${url}/key`}
                              className={`nav-link ${pathname.includes('key') ? 'active' : ''}`}
                        >
                            Clés et documents <i className="fas fa-key"></i>
                        </Link>
                    </li>
                    {canViewOperationUsers(operationId) && <li className="nav-item" role="presentation">

                        <Link to={`${url}/user`}
                              className={`nav-link ${pathname.includes('user') ? 'active' : ''}`}
                        >
                            Utilisateurs <i className="fas fa-users"></i>
                        </Link>
                    </li>}
                </ul>

                <div className="tab-content" id="myTabContent">
                    <div className={`tab-pane fade show active`}
                         role="tabpanel"
                         aria-labelledby="home-tab">

                        <Route path={[url, `${url}/statistics`]} exact>
                            {/*eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {useMemo(() => <StatisticsView operationId={operationId}/>, [operationId])}
                        </Route>

                        <Route path={[`${url}/lot`]} exact>
                            {/*eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {useMemo(() => <LotList data={lots} loading={isLoadingLots}/>, [lots, reserves, isLoadingLots])}
                        </Route>

                        <Route path={`${url}/reserve`}>
                            {/*eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {useMemo(() => <ReserveList data={reserves} loading={isLoadingReserves}/>, [lots, reserves, isLoadingReserves])}
                        </Route>

                        <Route path={`${url}/enterprise`}>
                            {/*eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {useMemo(() => <EnterpriseCorpEtatList data={enterprises} loading={isLoadingEnterprises}/>, [enterprises, isLoadingEnterprises])}
                        </Route>

                        <Route path={`${url}/key`}>
                            {/*eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {useMemo(() => <KeyDocumentList operationId={operationId} data={elements} loading={isLoadingElements}/>, [elements, isLoadingElements])}
                        </Route>

                        {canViewOperationUsers(operationId) && <Route path={`${url}/user`}>
                            {/*eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {/*<UserOperationAdmin operationId={operationId}/>*/}
                            {UserAdminScreenMemoized}
                        </Route>}
                    </div>
                </div>
            </div>
        </Animated>

        <Footer/>
    </>;
}
